const CoinSwap01 = ({
  color = 'currentColor',
  width = 21,
  height = 20,
}: {
  color?: string
  width?: number
  height?: number
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 21 20"
      fill="none"
    >
      <path
        d="M5.50008 5.00008L7.16675 3.33341M7.16675 3.33341L5.50008 1.66675M7.16675 3.33341H5.50008C3.65913 3.33341 2.16675 4.8258 2.16675 6.66675M15.5001 15.0001L13.8334 16.6667M13.8334 16.6667L15.5001 18.3334M13.8334 16.6667H15.5001C17.341 16.6667 18.8334 15.1744 18.8334 13.3334M11.6811 11.1811C12.3329 11.4924 13.0628 11.6667 13.8334 11.6667C16.5948 11.6667 18.8334 9.42817 18.8334 6.66675C18.8334 3.90532 16.5948 1.66675 13.8334 1.66675C11.072 1.66675 8.83341 3.90532 8.83341 6.66675C8.83341 7.43734 9.00774 8.16723 9.3191 8.81911M12.1667 13.3334C12.1667 16.0948 9.92817 18.3334 7.16675 18.3334C4.40532 18.3334 2.16675 16.0948 2.16675 13.3334C2.16675 10.572 4.40532 8.33341 7.16675 8.33341C9.92817 8.33341 12.1667 10.572 12.1667 13.3334Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default CoinSwap01
